<template>
  <div class="mx-2 py-2 sm:px-6">
    <base-card class="space-y-4">
      <div class="border-b border-gray-200 pb-5">
        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
          <h3 class="text-lg font-bold leading-6 text-gray-900">
            Penerimaan Retur Barang dari Stockist Center
          </h3>
        </div>
      </div>

      <div class="flex flex-col space-y-4">
        <div class="flex items-center justify-end space-x-2">
          <retur-receivement-table-filter
            v-model="filter"
            @filter="onFilter"
            @search="onSearch"
          />
        </div>

        <retur-shipment-table @page-change="onPageChange" @detail="onDetail" />
      </div>
    </base-card>

    <retur-shipment-detail-modal
      :visible="detailModal.visible"
      @close="detailModal.visible = false"
      @shipped="onShipped"
      @received="onReceived"
    />

    <loading v-if="isLoading" />
  </div>
</template>

<script>
import ReturShipmentTable from '@/components/retur-shipment/retur-shipment-table.vue';
import ReturShipmentDetailModal from '@/components/retur-shipment/retur-shipment-detail-modal.vue';
import ReturReceivementTableFilter from '@/components/retur-shipment/retur-receivement-table-filter.vue';
import { readReturReceivement } from '@/mixins/retur-shipment/read-retur-receivement.mixin';

export default {
  mixins: [readReturReceivement],
  components: {
    ReturShipmentTable,
    ReturShipmentDetailModal,
    ReturReceivementTableFilter,
  },
  data() {
    return {
      originOfficeCategoryName: 'Stockist Center',
    };
  },
};
</script>
